import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnimationOptions } from 'ngx-lottie';
import { PartnerService } from 'src/app/aplication/service/partners.service';

@Component({
  selector: 'app-add-partner',
  templateUrl: './add-partner.component.html',
  styleUrl: './add-partner.component.scss'
})
export class AddPartnerComponent {

  formPartner!:FormGroup
  loaded:boolean=true;

  @Output() onPartnerAdded = new EventEmitter<void>();
  
  animationLoading: AnimationOptions = {
    path: '../../../../../../../../assets/Animations/animationLoader.json',
  };

  constructor(private partnerService: PartnerService) { }

    ngOnInit(): void {
      this.formPartner = new FormGroup({
        name: new FormControl('', [Validators.required]),
        cpfCnpj: new FormControl('', [Validators.required, Validators.minLength(11)]),
        email: new FormControl('', [Validators.required, Validators.email]),
        phone: new FormControl('', [Validators.required]),
        from: new FormControl(''),
        address: new FormControl(''),
      });
    }


    AddPartner(){
      if(this.formPartner.valid){
        this.loaded=false;
        this.partnerService.Add(this.formPartner.value).subscribe({
          next: (response) => {
            console.log('Parceiro criado com sucesso:', response);
            this.loaded = true;
            this.formPartner.reset();
            this.onPartnerAdded.emit();
          },
          error: (error) => {
            console.error('Erro ao criar parceiro:', error);
            this.loaded = true;
          }
        });
      }
    }
}
